import { render, staticRenderFns } from "./majorProject.vue?vue&type=template&id=3f3a2b26&scoped=true"
import script from "./majorProject.vue?vue&type=script&lang=js"
export * from "./majorProject.vue?vue&type=script&lang=js"
import style0 from "./majorProject.vue?vue&type=style&index=0&id=3f3a2b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a2b26",
  null
  
)

export default component.exports